import React from 'react';
import { ErrorScreen } from '../components/screen/error';
import {
	hasOfertaFromExternalContent,
	isCallCenterForm,
	isCallMeForm,
	isLeadVentaForm,
	isSolucionesEstandarizadasForm,
} from '../helpers/form-helpers';
import { externalContentManager } from '../service/external-content';
import { TheOriginalsFest2026Form } from './adhoc/theoriginals-2026/theoriginalsfest-form';
import { CallCenterForm } from './lead-venta/call-me/call-center-form';
import { CallMeForm } from './lead-venta/call-me/call-me-form';
import { LeadVentaForm } from './lead-venta/lead-venta-form';
import { LeadVentaOfertaForm } from './lead-venta/lead-venta-oferta-form';
import { SolucionesEstandarizadasForm } from './lead-venta/soluciones-estandarizadas/soluciones-estandarizadas-form';
import { ProspectVentaForm } from './prospect-venta/prospect-venta-form';
import { TestForm } from './test/test-form';

export const FormController = () => {
	const formName = externalContentManager.formName;

	// ADHOCS
	if (formName == 'adhoc-theoriginalsfest-2026') {
		return <TheOriginalsFest2026Form />;
	}
	if (formName == 'test') {
		return <TestForm />;
	}

	// PROSPECTS VENTA
	if (formName.startsWith('prospect_venta')) {
		return <ProspectVentaForm />;
	}

	// LEADS VENTA
	if (isCallMeForm()) {
		return <CallMeForm />;
	}
	if (isCallCenterForm()) {
		return <CallCenterForm />;
	}
	if (isSolucionesEstandarizadasForm()) {
		return <SolucionesEstandarizadasForm />;
	}
	if (hasOfertaFromExternalContent()) {
		return <LeadVentaOfertaForm />;
	}
	if (isLeadVentaForm()) {
		return <LeadVentaForm />;
	}

	return <ErrorScreen log="No se ha encontrado el tipo de formulario" />;
};
